"use strict";
// Shape
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=shapes.js.map